import { css } from "@emotion/react";

export const footerCss = css({
  padding: "6px 0 0 16px",
});
